exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table, th, td {       \r\n    border: none !important;\r\n    border-collapse: collapse;\r\n}\r\n\r\ntable > thead > tr > th {\r\n    text-align: center;\r\n    padding: 10px;\r\n    border-bottom: 1px solid #BEC8D2 !important;\r\n}\r\n\r\ntable > tbody > tr > td {\r\n    text-align: left;   \r\n    border-bottom: 1px solid #BEC8D2 !important; \r\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// D:/GITHUB/F210/V18/rec_ng_renta210v18/node_modules/css-loader?{"sourceMap":false,"importLoaders":1}!D:/GITHUB/F210/V18/rec_ng_renta210v18/node_modules/postcss-loader?{"ident":"postcss"}!D:/GITHUB/F210/V18/rec_ng_renta210v18/src/assets/styles/table.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/assets/styles/table.css
// module chunks = styles